import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExamScheduleDialogBoxComponent } from '../exam-schedule-dialog-box/exam-schedule-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-exam-schedule',
  templateUrl: './exam-schedule.component.html',
  styleUrls: ['./exam-schedule.component.scss']
})
export class ExamScheduleComponent implements OnInit{
  APIService: any;
  dialogRef: MatDialogRef<any>;
  SessionNo: any;
  ExamScheduleSearchForm : FormGroup;
  examscheduleList: any;
  filteredListExamSch: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService,
    private spinner:NgxSpinnerService,
    private dialog:MatDialog, private fb: FormBuilder,
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.getExmSchData(this.SessionNo);
    }
    this.ExamScheduleSearchForm = this.fb.group({
      SearchString: new FormControl ('')
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.getExmSchData(this.SessionNo);
      }
    );
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getExmSchData(this.SessionNo);
  }

 
  getExmSchData(SnNo) {
    this.examscheduleList =[]
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = SnNo
    this.umsService.getExmSch(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.examscheduleList = res.data;
        // this.filteredListExamSch = this.examscheduleList.slice();
        this.totalItems = res.data[0].TotalRecords;
      }else{
        this.spinner.hide();
      }
     
      });
  }

  keypress(){
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      if(this.ExamScheduleSearchForm.value['SearchString'] === '' || this.ExamScheduleSearchForm.value['SearchString'] == null){
        const payload = {};
        payload['PageSize'] = this.pageSize;
        payload['PageNumber'] = this.currentPage;
        payload['LoginId'] = sessionStorage.getItem('userId');
        payload['ShSnNo'] = this.SessionNo
        this.umsService.getExmSch(payload).subscribe(res => {
          this.spinner.hide();
          this.examscheduleList = res.data;
          this.filteredListExamSch = this.examscheduleList.slice();
          this.totalItems = res.data[0].TotalRecords;
          });
      }
      else{
        let payload = {}
        payload['SearchString'] = this.ExamScheduleSearchForm.value['SearchString'];
        payload['PageSize'] = this.pageSize;
        // payload['PageNumber'] = this.currentPage;
        payload['LoginId'] = sessionStorage.getItem('userId');
        payload['ShSnNo'] = this.SessionNo
        if (payload['SearchString'] === "") {
          payload['PageNumber'] = this.currentPage;
        } else {
          payload['PageNumber'] = 1;
        }
        this.umsService.searchExmSch(payload).subscribe(res => {
          if(res.status){
            this.examscheduleList = res.data;
            this.totalItems = res.data[0].TotalRecords;
          }
          else{
            this.examscheduleList = [];
            this.totalItems = 0;
          }
         
          }, (ERROR: HttpErrorResponse) => {
            this.examscheduleList = [];
          });
      }
    },1000)
    
   
  }
  addnewrecord() {
    const dialogRef = this.dialog.open(ExamScheduleDialogBoxComponent, {
      width: '75vh',
      data: {key : "New"},
      disableClose: true 
    }); 
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getExmSchData(this.SessionNo);
    });
  }

  editData(k){ 
    const dialogRef = this.dialog.open(ExamScheduleDialogBoxComponent, {
      width: '75vh',
      // height:'85vh',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.getExmSchData(this.SessionNo);
    });
  }

  deleteData(k){
    const dialogRef = this.dialog.open(ExamScheduleDialogBoxComponent, {
      width: '75vh',
      data: { selected: k, key : "Delete"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getExmSchData(this.SessionNo);
    });
  }

  print(){
    
  }
}
